/**
 * Sculpt-mode brush cursor.
 *
 * Thin wrapper around the shared BrushCursor — resolves sculpt-specific
 * color (blue / red) and radius each frame.
 */

import { useCallback } from "react";
import * as THREE from "three/webgpu";
import { useStore } from "../app/store.ts";
import {
  BrushCursor,
  type BrushCursorState,
  type BrushCursorStyle,
} from "./BrushCursor.tsx";

const COLOR_ADD = new THREE.Color(0x4a90d9);
const COLOR_SUB = new THREE.Color(0xd94a4a);

export function SculptCursor({
  cursorRef,
}: {
  cursorRef: React.MutableRefObject<BrushCursorState>;
}) {
  const getStyle = useCallback((): BrushCursorStyle | null => {
    const sm = useStore.getState().sculptMode;
    if (!sm) return null;
    return {
      color: sm.invert ? COLOR_SUB : COLOR_ADD,
      radius: sm.radius,
    };
  }, []);

  return <BrushCursor cursorRef={cursorRef} getStyle={getStyle} />;
}
